import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'poster' | 'horizontal';
}

export default function MovieCard({ movie, variant = 'poster' }: MovieCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${movie.id}`}
        className="flex gap-4 p-3 rounded-lg bg-background-100 hover:bg-background-200/70 card-hover cursor-pointer group"
      >
        <div className="w-24 h-32 shrink-0 rounded-md overflow-hidden">
          <img
            src={movie.image}
            alt={movie.title}
            title={`${movie.title} - 春色影视高清在线观看`}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex flex-col justify-between py-1 min-w-0">
          <div>
            <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
              {movie.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{movie.description}</p>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-[10px]"></i>
              </span>
              {movie.rating}
            </span>
            <span>{movie.year}</span>
            <span>{movie.region}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${movie.id}`}
      className="block group cursor-pointer"
    >
      <div className="relative rounded-lg overflow-hidden card-hover bg-background-100">
        <div className="aspect-[2/3] w-full">
          <img
            src={movie.image}
            alt={movie.title}
            title={`${movie.title} - 春色影视高清在线观看`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
        </div>
        {movie.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
            热门
          </span>
        )}
        {movie.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-950 text-xs font-semibold whitespace-nowrap">
            新上
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1">
            {movie.title}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="flex items-center gap-0.5 text-xs text-accent-500">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-[10px]"></i>
              </span>
              {movie.rating}
            </span>
            <span className="text-xs text-foreground-600">{movie.year}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}